// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, setBookMarkJobByProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSetBookMarkJobByProfessionalApi = createAsyncThunk("hitSetBookMarkJobByProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + setBookMarkJobByProfessional;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const setBookMarkJobByProfessionalSlice = createSlice({
  name: "setBookMarkJobByProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitSetBookmarkProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSetBookMarkJobByProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSetBookMarkJobByProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSetBookMarkJobByProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitSetBookmarkProfessionalData } = setBookMarkJobByProfessionalSlice.actions;
export default setBookMarkJobByProfessionalSlice.reducer;
